import { Tracking } from "restaumatic-client";
const sentToAnalytics = new Set();
export function getVariant(experiment) {
    const variants = getAllVariants();
    if (!(experiment.name in variants)) {
        variants[experiment.name] = weightedRandom(experiment.variants);
        console.log(`[FieldTest] Experiment ${experiment.name}: selecting and saving variant ${variants[experiment.name]}`);
        setAllVariants(variants);
    }
    else {
        console.log(`[FieldTest] Experiment ${experiment.name}: already chose variant ${variants[experiment.name]}`);
    }
    const value = variants[experiment.name];
    if (!sentToAnalytics.has(experiment.name)) {
        Tracking.trackEvent({
            tag: "ExperienceImpression",
            contents: {
                experiment: experiment.name,
                variant: value,
            },
        });
        sentToAnalytics.add(experiment.name);
    }
    return value;
}
export function clearVariant(experiment) {
    const variants = getAllVariants();
    delete variants[experiment.name];
    setAllVariants(variants);
}
const KEY = "fieldTestExperiments";
function getAllVariants() {
    try {
        return JSON.parse(localStorage[KEY]);
    }
    catch (e) {
        return {};
    }
}
function setAllVariants(x) {
    localStorage[KEY] = JSON.stringify(x);
}
// Exported for tests
export function weightedRandom(variants) {
    // <https://en.wikipedia.org/wiki/Reservoir_sampling#Algorithm_A-Res>,
    // but specialized to k=1, where the priority queue degenerates to just a variable and comparison
    let acc = null;
    for (const [value, weight] of variants) {
        const random = Math.pow(Math.random(), 1 / weight);
        if (!acc || random > acc[1]) {
            acc = [value, random];
        }
    }
    if (!acc) {
        throw new Error("Empty list of variants");
    }
    return acc[0];
}
